<div id="pieChartContent">
	<canvas id="Config_PieChart"
			style="width:800px ;height:450px"> {{Config_PieChart}} </canvas>
</div>